
export const CHART_CONFIG = {
    READY_TO_SETUP: { color: '#0568ae', label: 'ready for setup' },
    READY_TO_SETUPSAMSUNG: { color: '#0568ae', label: 'ready for setup' },
    AWAITING_SIGNUP: { color: '#6fa8d0', label: 'available to add' },
    ACTIVE: { color: '#b9d5e8', label: 'active' },
    PROCESSING: { color: '#FF585D', label: 'Processing' },
    ENROLLED_ACTIVE: { color: '#1483D9', label: 'Enrolled' },
    ENROLLED_NOT_ACTIVE: { color: '#B9D5E8', label: 'Enrolled, Not Active' },
    NOT_ENROLLED: { color: '#7F7F7F', label: 'not registered' },
    ENROLLED_SINGLE_PROGRAM: { color: '#649AC8', label: 'registered in 1 program' },
    ENROLLED_MULTIPLE_PROGRAMS: { color: '#1F56A9', label: 'registered in multiple programs' },
    OUT_OF_COMPLIANCE: { color: '#cccccc', label: 'not compliant' },
    SAMSUNG_CLAIM_SUCCESS: { color: '#007a3e', label: 'claimed (Samsung)' },
    ABM_CLAIM_SUCCESS: { color: '#007a3e', label: 'claimed (Apple)' },
    ZTP_CLAIM_SUCCESS: { color: '#006400', label: 'claimed (Android™)' },
    CLAIM_SUCCESS: { color: '#035527', label: 'claimed' },
    NOT_CLAIMED: { color: '#e57200', label: 'not claimed' },
    CLAIM_PENDING:{color: '#6BA179', label: 'claim pending'},
    UNCLAIM_PENDING:{color: '#9B8E82', label: 'unclaim pending'},
    CLAIM_PENDING_Samsung:{color: '#6BA179', label: 'claim pending (Samsung)'},
    UNCLAIM_PENDING_Samsung:{color: '#9B8E82', label: 'unclaim pending (Samsung)'},
    CLAIM_PENDING_Android:{color: '#6BA179', label: 'claim pending (Android™)'},
    UNCLAIM_PENDING_Android:{color: '#9B8E82', label: 'unclaim pending (Android™)'},
    CLAIM_PENDING_Apple:{color: '#6BA179', label: 'claim pending (Apple)'},
    UNCLAIM_PENDING_Apple:{color: '#9B8E82', label: 'unclaim pending (Apple)'},
    READY_TO_SETUP_OEM: { color: '#0568ae', label: 'ready to set up' },
    PROCESSING_OEM: { color: '#FF585D', label: 'not claimed' },
    Claimed_Samsung: { color: '#035527', label: 'claimed (Samsung)' },
    Claimed_Android: { color: '#035527', label: 'claimed (Android™)' },
    Claimed_Apple: {color: '#035527', label: 'claimed (Apple)'},
    Not_Claimed: { color: '#e57200', label: 'not claimed' },
    FUTURE_ENROLLMENT: { color: '#ea7400', label: 'not enrolled' },
    ZTP: { color: '#707070', label: 'Android™ Zero-touch registrations' },
    ABM: { color:'#000000', label:'Apple Business registrations'},
    KME: { color: '#0077DC', label: 'Samsung Knox Mobile Enrollment registrations' }
};

export const EFOTA_CHART_CONFIG = {
    ACTIVE: { color: '#1D83D9', label: 'active' },
    PROCESSING: { color: '#FF585D', label: 'Processing' },
    AWAITING_SIGNUP: { color: '#707070', label: 'available to add' },
    Complete: {color: '#7ED321', label: ' Complete'},
    Open: {color: '#1D83D9', label: ' Open'},
    Cancel: {color: '#707070', label: ' Cancelled'},
    Processing: {color: '#FF585D', label: ' In Progress'},
    noOfReports : {color: "#1D83D9", label:'New Reports'}
};